import { Component, HostListener, ElementRef } from '@angular/core';
import { BackComponent } from "./back.component";
import { FlashComponent } from "./flash.component";
//import { NeverumeComponent } from "./../neverume.component";     
import { Directionality } from '@angular/cdk/bidi';

@Component({
  selector: 'neverume-vision',
  templateUrl: './vision.component.html',
  styleUrl: './vision.component.scss',
  providers: [BackComponent, FlashComponent],
  standalone: !true
})
    
export class VisionComponent {

	currentDirection: any;

	  private touchStartX = 0;
	  private touchStartY = 0; 
	  private scrollX = 0;
	  private scrollY = 0;
	  private containerWidth = 0;
	  private windowWidth = 0;
	  private resizeTimeout: any;
	  private isHorizontalScrollEnd = false;
	  private lastScrollX = 0;
	  private lastScrollY = 0;
	  private containerHeight = 0;
	  private windowHeight = 0;
	  private touch = 0;
	  private isVerticalScrollEnd = false;
	  private isInitialScroll = true;

	constructor(private directionality: Directionality, private elementRef: ElementRef) {
		this.currentDirection = this.directionality.value;
	}
	

	 ngAfterViewInit() {
		    this.windowWidth = window.innerWidth;
		    this.windowHeight = window.innerHeight;
		    this.scrollX = this.lastScrollX;
		    this.scrollY = this.lastScrollY; 
		  }

	 ngOnDestroy() {
		    clearTimeout(this.resizeTimeout);
	}
		  
	handleVerticalScroll(event: Event) {

		    if ((event as TouchEvent).touches) {
			      const container = this.elementRef.nativeElement.querySelector('.vi');
			      if (container && (event as TouchEvent).touches.length === 1) {
			          const touch = (event as TouchEvent).touches[0];
			      }
			        
			    } else {
			        const deltaY = (event as WheelEvent).deltaY;
			        const deltaX  = (event as WheelEvent).deltaX;

			        const container = this.elementRef.nativeElement.querySelector('.vi');
			        if (container) {
			                event.preventDefault();
			                if(this.scrollX <0){
			            	container.scrollLeft = 0;
			            }else if(container.scrollLeft>(container.scrollWidth - container.offsetWidth)){
			            	container.scrollLeft =  container.scrollWidth - container.offsetWidth;
			            } else {
			                container.scrollLeft += deltaY;
			                container.scrollLeft += deltaX;
			            }
			        }
			   }
		  }
	 

	  @HostListener('touchstart', ['$event'])
	  onTouchStart(event: TouchEvent) {
		    if (event.touches.length === 1) {
		        const touch = event.touches[0];
		        this.touchStartX = touch.clientX;
		        this.touchStartY = touch.clientY;
		    }
		    event.preventDefault()
	  }

	  @HostListener('touchmove', ['$event'])
	  onTouchMove(event: TouchEvent) {
		    if (event.touches.length === 1) {
		    	console.log(event);
		        const touch = event.touches[0];
		        const touchX = touch.clientX;
		        const touchY = touch.clientY;
		        const deltaX = touchX - this.touchStartX;
		        const deltaY = touchY - this.touchStartY;
	        	this.touchStartX = touchX;
			    this.touchStartY = touchY;
			     
		        const container = this.elementRef.nativeElement.querySelector('.vi');

		        if (container) {
		        	container.scrollLeft -= deltaX*4;
		        	container.scrollLeft += deltaY*2;
		        }
		      }
		    event.preventDefault();
	  }
}
